'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('material-ui/styles/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The content area of a notification as shown in https://material.io/guidelines/patterns/notifications.html#notifications-anatomy-of-a-notification.
 * 
 * @author Timo Hanisch <timohanisch@googlemail.com>
 * @since 0.1.0
 */
var NotificationContentArea = function (_React$PureComponent) {
    _inherits(NotificationContentArea, _React$PureComponent);

    function NotificationContentArea() {
        _classCallCheck(this, NotificationContentArea);

        return _possibleConstructorReturn(this, (NotificationContentArea.__proto__ || Object.getPrototypeOf(NotificationContentArea)).apply(this, arguments));
    }

    _createClass(NotificationContentArea, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                avatar = _props.avatar,
                text = _props.text,
                title = _props.title;

            return _react2.default.createElement(
                'div',
                { style: NotificationContentArea.STYLES.container },
                _react2.default.createElement(
                    'div',
                    { style: NotificationContentArea.STYLES.textContainer },
                    _react2.default.createElement(
                        'span',
                        { style: NotificationContentArea.STYLES.title },
                        title
                    ),
                    _react2.default.createElement(
                        'span',
                        { style: NotificationContentArea.STYLES.text },
                        text
                    )
                ),

                // If no avatar was passed we do not render anything otherwise we render the avatar
                // and apply our styles to it
                !!avatar && _react2.default.cloneElement(avatar, { style: NotificationContentArea.STYLES.avatar })
            );
        }
    }]);

    return NotificationContentArea;
}(_react2.default.PureComponent);

NotificationContentArea.propTypes = {
    /* Content text to be rendered in the notification */
    text: _propTypes2.default.string.isRequired,

    /* Title of the content rendered in the notificaton */
    title: _propTypes2.default.string.isRequired,

    /* An avatar (or large icon) to be shown on the right side of a notification */
    avatar: _propTypes2.default.node
};
NotificationContentArea.defaultProps = {
    avatar: null
};
NotificationContentArea.STYLES = {
    avatar: {
        marginLeft: 8
    },
    container: {
        padding: '8px 16px 16px 16px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    text: {
        fontSize: 14,
        color: _colors.grey600,
        marginTop: 2
    },
    textContainer: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: 392
    },
    title: {
        fontSize: 15,
        fontWeight: 600
    }
};
exports.default = NotificationContentArea;
module.exports = exports['default'];